// @flow

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'client/components/translate';
import { getPrimaryAndSecondaryName } from 'client/components/member/getName';
import type { MemberType } from 'web-core/types/member';

type Props = {
  member: MemberType,
  required: boolean,
  commonMemberTranslations: Object,
};

const mapStateToProps = ({ translations }) => ({
  commonMemberTranslations: _.get(translations, 'common.member', {}),
});

class MemberListItemName extends React.PureComponent<Props> {
  static defaultProps = {
    member: {},
    clickHandler: () => {},
    required: false,
  };

  render() {
    const { member, required, commonMemberTranslations } = this.props;

    const { primaryName, secondaryName } = getPrimaryAndSecondaryName({
      member,
      commonMemberTranslations,
    });

    return (
      <div>
        <div className="name grey-2-color">{primaryName}</div>
        <div className="relation grey-3-color">
          {secondaryName}
          {required && (
            <span>
              {' '}
              (<Translate path="common.required" />)
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, {})(MemberListItemName);
